<template>
    <div id="homeBox">
        <div class="flexcenter" id="flexcenter">
            <!-- 导出表格按钮      -->
            <el-button type="text" style="height: 2.5rem"  icon="el-icon-download"  @click="download">导出表格</el-button>
            <!-- 搜索区域-->
            <div style="margin-right: 20px">
                <span class="titlew">选择食堂</span>
                <el-select
                        size="mini"
                        style="width: 200px ; margin-right:10px;margin-left: 5px"
                        clearable class="input-width"
                        placeholder="请选择食堂"
                        v-model="searchCanteen"
                        filterable>
                    <el-option
                            v-for="item in canteenData"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
                <span class="titlew">选择餐别</span>
                <el-select
                        size="mini"
                        style="width: 200px ; margin-right:10px;margin-left: 5px"
                        clearable class="input-width"
                        placeholder="请选择餐别"
                        v-model="searchCatering"
                        @change="caterChange"
                        filterable>
                    <el-option
                            v-for="item in cateringData"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
                <span class="titlew" >选择日期</span>
                <el-date-picker
                        size="mini" style="width:200px; margin-right: 10px"
                        v-model="searchDate"
                        type="date"
                        :picker-options="dateLimit"
                        placeholder="请选选择日期"
                        value-format="yyyy-MM-dd"
                        clearable
                >
                </el-date-picker>
                <!-- 搜索框 -->
                <el-input
                        size="mini"
                        style="width: 200px  "
                        placeholder="请输入搜索内容"
                        v-model="searchData"
                        clearable>
                </el-input>
                <!-- 搜索按钮 -->
                <el-button  class="mrl15 " icon="el-icon-search" circle  @click="Search" size="mini"></el-button>
            </div>

        </div>
        <!--  表格  -->
        <div class="itemTrading  ">
        <el-table
                id="eltable"
                ref="detailTable"
                highlight-current-row
                size="mini"
                :max-height="tableHeight"
                :data="tableData"
                style="width: 100%"
                stripe
                border
                show-summary
                :summary-method="getSummaries"
                :header-cell-style="{background:'#eef1f6',color:'black'}"
                :header-row-style="{height:'50px'}"
        >
            <el-table-column
                    :highlight-current-row="true"
                    type="index"
                    label="序号"
                    width="50">
            </el-table-column>
            <el-table-column
                    prop="dishName"
                    label="菜品名称"
                    width="300px"
                    show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                    prop="catering"
                    label="餐别"
                    show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                    prop="filePath"
                    width="120px"
                    label="图片"
            >
                <template slot-scope="scope">
                    <el-image style="width: 60px; height: 60px;margin-left: 20px;margin-bottom: -10px"
                              :src="'https://'+scope.row.filePath"
                              :preview-src-list="['https://'+scope.row.filePath]" :key="scope.row.id"
                              slot="reference" :alt="'https://'+scope.row.filePath"
                    >
                        <div slot="error" class="image-slot" style="text-align: center;line-height: 60px">
                            <div>无</div>
                        </div>
                    </el-image>

                </template>
            </el-table-column>
            <el-table-column
                    prop="price"
                    label="原价"
                    show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                    prop="disprice"
                    label="售价"
                    show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                    prop="foodType"
                    label="类型"
                    show-overflow-tooltip
            >
                <template slot-scope="scope" >
                    <div >
                        <span v-if="scope.row.foodType==1">小碗菜</span>
                        <span v-if="scope.row.foodType==2">熟食</span>
                        <span v-if="scope.row.foodType==3">主食</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                    prop="due"
                    label="预定(份)"
                    show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                    prop="paid"
                    label="已付款(份)"
                    show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                    prop="unpaid"
                    label="未付款(份)"
                    show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                    prop="refunded"
                    label="已退款(份)"
                    show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                    prop="notGain"
                    label="待取(份)"
                    show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                    prop="gain"
                    label="已取(份)"
                    show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                    prop="sold"
                    label="已售金额(元)"
                    show-overflow-tooltip
            >
                <template slot-scope="scope">
                    <span>{{ scope.row.sold.toFixed(2) }}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="unsold"
                    label="未售金额(元)"
                    show-overflow-tooltip
            >
                <template slot-scope="scope">
                    <span>{{ scope.row.unsold.toFixed(2) }}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="refund"
                    label="退款金额(元)"
                    show-overflow-tooltip
            >
                <template slot-scope="scope">
                    <span>{{ scope.row.refund.toFixed(2) }}</span>
                </template>
            </el-table-column>

        </el-table>
        <!-- 父表格 -->
        </div>

        <!-- 分页器-->
        <div class="block">
            <div class="pages">
                <div class="choosepage flexother  fl">
                    <!--
                    small：是否使用小型分页样式
                    page-size:每页显示的条目数
                    page-sizes：每页显示个数选择器的选项设置
                    total：总条目数
                    current-page：当前页数，支持 .sync 修饰符
                    layout：组件布局，子组件名用逗号分隔
                    size-change：pageSize改变时会触发  回调参数为每页条数
                    current-change：currentPage 改变时会触发  回调参数为当前页
                    -->
                    <el-pagination
                            small
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :page-sizes="[10,20,30,40]"
                            :page-size="this.pageSize"
                            layout="total,sizes"
                            :total="this.total"
                    >
                    </el-pagination>
                    <!--
                    small：是否使用小型分页器
                    page-size:每页显示的条目数
                    page-sizes：每页显示个数选择器的选项设置
                    total：条目总数
                    current-page：当前页数，支持 .sync 修饰符
                    layout：组件布局，子组件名用逗号分隔
                    size-change：pageSize改变时会触发  回调参数为每页条数
                    current-change：currentPage 改变时会触发  回调参数为当前页
                    -->
                    <el-pagination
                            small
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :pager-count="5"
                            :page-size="this.pageSize"
                            layout="prev, pager, next, jumper"
                            :total="this.total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <!-- 分页器-->


    </div>
</template>

<script>
    import {baseerp} from "@/utils/baseUrl";
    // import * as API from "./api";
    import {mapActions} from "vuex";
    export default {
        name: "canteenStatement",
        components:{
            // addMenu
        },

        data(){
            return{
                delDialog:false,
                flowPath:false,
                searchDate:'',
                searchCatering:'',
                searchCanteen:'',
                searchData:'',
                addDialog:false,//编辑弹窗
                currentPage:1,
                pageSize:10,
                total:0,
                deldetail:'',
                dateLimit: {//日期选择限制
                    disabledDate: (time) => {
                        var now = new Date(); // 当前日期
                        var nowDayOfWeek = now.getDay(); // 今天本周的第几天
                        var nowDay = now.getDate();    // 当日
                        var nowMonth = now.getMonth(); // 当前月
                        var nowYear = now.getYear();   // 当前年
                        nowYear += (nowYear < 2000) ? 1900 : 0;
                        var weekEndDate = new Date(nowYear, nowMonth, nowDay + (6 - nowDayOfWeek) + 8);
                        return time.getTime() >  weekEndDate//禁用下周之后的所有日期
                    }
                },

                baseerp:'',
                // foodType:'',
                canteenData:[
                    {
                        id:1,
                        name:"西区食堂"
                    },
                    {
                        id:2,
                        name:"东区食堂"
                    },
                    {
                        id:3,
                        name:"岳达食堂"
                    },
                ],
                cateringData:[
                    // {
                    //     id:0,
                    //     name:"全部"
                    // },
                    {
                        id:1,
                        name:"早餐"
                    },
                    {
                        id:2,
                        name:"午餐"
                    },
                    {
                        id:3,
                        name:"晚餐"
                    },
                    {
                        id:4,
                        name:"夜宵"
                    },
                ],
                tableData: [],
                // tableData:[],
                tableHeight:0,//列表高度
                title:'',
                releaseDate:''
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },

        mounted(){

            // console.log(this.tableData.length)
            // this.getDataDict()
            this.getList()
            this.$nextTick(()=>{
                this.onResize();
            })
            // this.$refs.deliverlight.toggleRowExpansion(item,false)
            //公共样式
            this.baseerp=baseerp
            // this.searchCatering=0

            //将合计行调到导航栏上面
            //要想监听bodyWrapper滚动之后让headerWrapper跟footerWrapper一起滚动,
            // 把footerWrapper的滚动值赋值给bodyWrapper就可以了
            var tableBody = this.$refs.detailTable.$refs.footerWrapper
            // console.log(this.$refs.detailTable)
            tableBody.addEventListener('scroll', () => {
                // 滚动距离
                const scrollLeft = tableBody.scrollLeft
                this.$refs.detailTable.$refs.bodyWrapper.scrollLeft = scrollLeft
            })

            //获取当前日期
            let n=new Date()
            let y=n.getFullYear()
            let m=n.getMonth()+1
            let d=n.getDate()
            if(m<10){
                m='0'+m
            }
            if(d<10){
                d='0'+d
            }
            this.searchDate=y+'-'+m+'-'+d

        },

        methods:{
            caterChange(val){
                this.searchCatering=val
            },
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-83

            },
            ...mapActions(["getCurrentMenuId"]),

            //高度
            heightAuto(){
                this.tableHeight = window.innerHeight - document.getElementById('body').getBoundingClientRect().top -48 -36;
            },
            //关闭弹框
            close(){
                this.flowPath=false
                this.addDialog=false
            },
            //合计行
            getSummaries(param){
                // console.log(param)
                const { columns, data } = param;//columns表格每个标题列；表格每行数据
                const sums = [];
                columns.forEach((column, index) => {//循环取出每列数据
                    // console.log(column)
                    if (index === 0) {//如果为第一列
                        sums[index] = '合计';//将第一列赋值为合计
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));//循环每行数据，将每列数据取出
                    // console.log(values)
                    //every()是对数组中每一项运行给定函数，如果该函数对每一项返回true,则返回true
                    //isNaN在接收到一个值之后，会尝试将这个值转换为数值，如果能成功转换则返回false，否则返回true
                    if (!values.every(value => isNaN(value))&& column.property !== "price"&& column.property !== "disprice"&& column.property !== "foodType") {
                        //values
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        //sold,unsold,refund
                        if(column.property === "sold"||column.property === "unsold"||column.property === "refund"){
                            sums[index]=sums[index].toFixed(2);
                        }
                        // sums[index].toFixed(2);
                        // console.log("11",sums[index].toFixed(2))
                    } else {
                        sums[index] = '— —';
                    }
                });
                return sums;
            },
            //导出表格
            download(){

            },
            //页面搜索
            Search(){
                // if(this.searchCatering===''){
                //     this.$message.error('请选择餐别')
                // }

                // if(!this.searchDate){
                //     this.$message.error('请选择日期')
                // }
                // this.foodType=this.cpTypedata.id
                this.currentPage=1
            },
            //分页
            //监听pagesize改变的事件
            handleSizeChange(newsize) {
                //console.log(`每页 ${newsize} 条`);
                //最新的条数（newsize）赋值给 动态的 pageSize
                this.pageSize = newsize;    //动态改变
                this.getList()
                //获取到最新一页显示的数据  重新发送请求
                //this.dcslist()
            },
            // 监听 页码值 改变的数据
            //监听页码值改变的数据
            handleCurrentChange(newPage) {
                // console.log(`当前页: ${newPage}`);
                //把最新的页码（newPage）赋值给 动态的 currentPage
                this.currentPage = newPage;    //动态改变
                this.getList()
                //获取到最新页码值  重新发送请求
                //this.dcslist()
            },
            // //新增菜品
            // download(){
            //     this.title='菜谱发布'
            //     this.editData={
            //     }
            //     this.addDialog=true
            // },
            // //编辑菜品
            // editDish(val){
            //     this.title='编辑菜品'
            //     this.editData.id = val.id
            //     this.addDialog=true
            // },


            // //删除菜谱(父)
            // del(val){
            //     this.title='删除'
            //     this.editData=val
            //     this.deldetail='是否要删除'
            //     this.delDialog=true
            //
            // },
            // //菜谱确认作废(父)
            // submitdel(){
            //     this.remove()
            //     this.delDialog=false
            // },
            // //发布
            // cprelease(val){
            //     // console.log(val)
            //     this.releaseDate=val.date
            //     this.release()
            // },


            //流水列表
            async getList(val) {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                this.tableData=[
                    {dishName:"包子",catering:'早餐',filePath:"n.sinaimg.cn/front/779/w2048h2731/20181208/w3Ut-hprknvt8386137.jpg",price:2,
                        disprice:2,foodType:3,due:40,paid:30,unpaid:10,refunded:10,notGain:10,gain:20,sold:40,unsold:20,refund:20},
                    {dishName:"风味茄子",catering:'午餐',filePath:"pic.rmb.bdstatic.com/fb8c7d47b3c0a98df318fcddf23f95fe.jpeg",price:3,
                        disprice:3,foodType:1,due:55,paid:50,unpaid:5,refunded:10,notGain:20,gain:30,sold:90,unsold:60,refund:30},
                    {dishName:"风味茄子",catering:'午餐',filePath:"pic.rmb.bdstatic.com/fb8c7d47b3c0a98df318fcddf23f95fe.jpeg",price:3,
                        disprice:3,foodType:1,due:55,paid:50,unpaid:5,refunded:10,notGain:20,gain:30,sold:90,unsold:60,refund:30},
                    {dishName:"风味茄子",catering:'午餐',filePath:"pic.rmb.bdstatic.com/fb8c7d47b3c0a98df318fcddf23f95fe.jpeg",price:3,
                        disprice:3,foodType:1,due:55,paid:50,unpaid:5,refunded:10,notGain:20,gain:30,sold:90,unsold:60,refund:30},
                    {dishName:"风味茄子",catering:'午餐',filePath:"pic.rmb.bdstatic.com/fb8c7d47b3c0a98df318fcddf23f95fe.jpeg",price:3,
                        disprice:3,foodType:1,due:55,paid:50,unpaid:5,refunded:10,notGain:20,gain:30,sold:90,unsold:60,refund:30},
                    {dishName:"风味茄子",catering:'午餐',filePath:"pic.rmb.bdstatic.com/fb8c7d47b3c0a98df318fcddf23f95fe.jpeg",price:3,
                        disprice:3,foodType:1,due:55,paid:50,unpaid:5,refunded:10,notGain:20,gain:30,sold:90,unsold:60,refund:30},
                    {dishName:"风味茄子",catering:'午餐',filePath:"pic.rmb.bdstatic.com/fb8c7d47b3c0a98df318fcddf23f95fe.jpeg",price:3,
                        disprice:3,foodType:1,due:55,paid:50,unpaid:5,refunded:10,notGain:20,gain:30,sold:90,unsold:60,refund:30},
                    {dishName:"风味茄子",catering:'午餐',filePath:"pic.rmb.bdstatic.com/fb8c7d47b3c0a98df318fcddf23f95fe.jpeg",price:3,
                        disprice:3,foodType:1,due:55,paid:50,unpaid:5,refunded:10,notGain:20,gain:30,sold:90,unsold:60,refund:30},
                    // {dishName:"风味茄子",catering:'午餐',filePath:"pic.rmb.bdstatic.com/fb8c7d47b3c0a98df318fcddf23f95fe.jpeg",price:3,
                    //     disprice:3,foodType:1,due:55,paid:50,unpaid:5,refunded:10,notGain:20,gain:30,sold:90,unsold:60,refund:30},
                ]
                this.total=this.tableData.length
                // let params = {
                //     currentPage:this.currentPage,
                //     pageSize:this.pageSize,
                //     startDate:this.startDate,
                //     endDate:this.endDate,
                //     // foodType:this.foodType
                // }
                // let res = await API.getList(params);
                // if (res.code == 1) {
                //     this.tableData=res.data
                //     // console.log(res.data,'list')
                //     this.total=res.total
                //     // this.tableData.forEach(item=>{
                //     //     item.createTime=item.createTime.substring(0,19)
                //     // })
                // } else if (res.code == -2) {
                //     this.$router.push('/login');
                //     this.$message.error(res.message);
                // } else {
                //     this.$message.error(res.message);
                // }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .flexcenter{
        min-width: 39.286rem;
        width: 100%;
        height: 2.857rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 0.857rem;
    }
    /deep/.el-table__expanded-cell{
        padding: 5px 0px;
    }
    /*/deep/{*/
    /*    .el-table {*/
    /*        overflow: auto;*/
    /*    }*/
    /*    .el-table__body-wrapper, .el-table__header-wrapper, .el-table__footer-wrapper {*/
    /*        overflow: visible;*/
    /*    }*/
    /*    .el-table::after {*/
    /*        position: relative !important;*/
    /*    }*/
    /*}*/

    /deep/{
        .el-table--scrollable-x .el-table__body-wrapper{
        overflow-x: hidden!important;
            z-index: 2!important;
        }
        .el-table__footer-wrapper {
            overflow-x: auto;
            border-top: 1px solid #f4f4f4;
        }
    }

    /*/deep/{*/
    /*    .el-table--enable-row-transition{*/
    /*        !*min-width: 53.571rem !important;*!*/
    /*    }*/
    /*    .el-button--text{*/
    /*        padding: 0 !important;*/
    /*        margin-left: 0 !important;*/
    /*        margin-right: 10px;*/
    /*    }*/
    /*    .el-tabs__content{*/
    /*        !*height: 90% !important;*!*/
    /*        overflow: visible !important;*/
    /*        height:calc(100% - 0.357rem) !important;*/
    /*    }*/
    /*}*/

    /deep/.is-leaf .cell .el-checkbox__input{
        display: none;
    }
    .m{
        padding-top: 1.429rem;
    }

    .fl{
        float: left;
        .el-button--primary{
            color: #efd773;
            background-color:white;
            border: 0;
            text-align: center;
            padding: 0;
            height: 2rem;
            width: 3.286rem;
            margin:0.857rem 0 0 0.714rem;
        }
    }
    .titlew{
        padding: 0 10px;
        font-size: 14px;
    }
    .fr{
        float:right;
    }

    .cl{
        clear: both;
    }
    .block{
        height: 34px;
        line-height: 30px;
        .pages{

            .flexother {

                display: flex;
                /*flex-flow: wrap;*/
                justify-content: space-between;
                align-items: center;
                position: fixed;
                bottom: 0;
            }
            .choosepage{
                /*min-width: 42.571rem;*/
                width:90%
            }
        }
    }
    /deep/.has-gutter tr td{
        /*background-color: red;*/
        font-weight: 600;
        background: rgb(446, 238, 217);
        /*background: rgb(238, 241, 246)*/
    }

    /deep/.el-table__header{
        width: 100% !important;
    }
    /deep/.el-table__body{
        width: 100% !important;

    }
</style>